import { HttpService } from '@/data/http/http-service';
import {
  ProjectVenue,
  VenueDefaultDatas,
} from '@/domain/project-venue/entities/project-venue.entity';
import { ProjectVenueGateway } from '@/domain/project-venue/gateways/project-venue.gateway';

import {
  getProjectsVenueDtoSchema,
  getProjectVenueDtoSchema,
} from './project-venue.dto.schema';
import { ProjectVenueMapper } from './project-venue.mapper';

export class ApiProjectVenueHttpGateway implements ProjectVenueGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_PROJECT,
  });

  async getAll(): Promise<ProjectVenue[]> {
    const url = '/seasons';
    const options = { params: { $limit: 1000 } };
    const response = await this.http.get(url, options);
    const result = getProjectsVenueDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const projects: ProjectVenue[] = result.data.data.map((x) =>
      ProjectVenueMapper.dtoToEntity(x),
    );
    return projects;
  }

  async get(id: number): Promise<ProjectVenue> {
    const url = `/seasons/${id}`;
    const response = await this.http.get(url);
    const result = getProjectVenueDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const project = ProjectVenueMapper.dtoToEntity(result.data);
    return project;
  }

  async create(projectVenue: ProjectVenue): Promise<void> {
    const url = '/seasons';
    const data = ProjectVenueMapper.entityToDto(projectVenue);
    const response = await this.http.post(url, data);
    if (response.status === 201) {
      return;
    } else {
      throw 'error on creation';
    }
  }

  async delete(id: number): Promise<void> {
    const url = `/seasons/${id}`;
    const response = await this.http.delete(url);
    if (response.status === 200) {
      return;
    } else {
      throw 'error on delete';
    }
  }

  async edit(project: ProjectVenue): Promise<void> {
    const url = `/seasons/${project.id}`;
    const data = ProjectVenueMapper.entityToDto(project);
    const response = await this.http.patch(url, data);
    if (response.status === 200) {
      return;
    } else {
      throw 'error on edition';
    }
  }

  async saveVenueDefaultDatas({
    projectId,
    properties,
  }: {
    projectId: number;
    properties: VenueDefaultDatas;
  }): Promise<{ success: boolean }> {
    const url = `/seasons/${projectId}`;
    const response = await this.http.patch(url, { properties });
    if (response.status === 200) {
      return { success: true };
    } else {
      throw 'error on default datas save';
    }
  }
}
